import a from "./_Hash.js";
import t from "./_ListCache.js";
import e from "./_Map.js";
function o() {
  this.size = 0, this.__data__ = {
    hash: new a(),
    map: new (e || t)(),
    string: new a()
  };
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_mapCacheClear.js
// module id = 1533
// module chunks = 67